(() => {
  const setActiveContent = (section, activeId) => {
    const contentEls = section.querySelectorAll(".content-tabs__content");
  
    // Remove active and animate classes from all content elements
    contentEls.forEach((el) => {
      el.classList.remove("content-tabs__content--active");
      el.classList.remove("animate");
    });
  
    // Activate all content elements with the matching data-content-tab-id
    const activeContents = section.querySelectorAll(
      `[data-content-tab-id="${activeId}"].content-tabs__content`
    );
    activeContents.forEach((activeContent) => {
      activeContent.classList.add("content-tabs__content--active");
      setTimeout(() => {
        activeContent.classList.add("animate");
      }, 100);
    });
  };

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll(".content-tabs__tab");

    tabs.forEach((tab) => {
      const currentId = tab.dataset.contentTabId;

      tab.addEventListener("click", (event) => {
        if (
          !event.currentTarget.classList.contains("content-tabs__tab--active")
        ) {
          // Reset all tabs
          tabs.forEach((el) => {
            el.classList.remove("content-tabs__tab--active");
            const icon = el.querySelector(".icon");
            if (icon) {
              icon.classList.remove("icon-minus");
              icon.classList.add("icon-plus");
              const svg = icon.querySelector("svg");
              svg.innerHTML = `
                <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
                </foreignObject>
                <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
                <path d="M20.9111 15L20.9111 25" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <path d="M15.9048 20H25.9175" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <defs>
                  <clipPath id="bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                    <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                  </clipPath>
                </defs>
              `;
            }
          });

          // Set active tab and icon
          tab.classList.add("content-tabs__tab--active");
          const icon = tab.querySelector(".icon");
          if (icon) {
            icon.classList.remove("icon-plus");
            icon.classList.add("icon-minus");
            const svg = icon.querySelector("svg");
            svg.innerHTML = `
              <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
              </foreignObject>
              <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
              <path d="M15.9048 20H25.9175" stroke="#858585" stroke-width="3" stroke-linecap="round"/>
              <defs>
                <clipPath id="bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                  <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                </clipPath>
              </defs>
            `;
          }

          setActiveContent(section, currentId);
        }
      });

      tab.addEventListener("keydown", (event) => {
        if (
          !event.currentTarget.classList.contains(
            "content-tabs__tab--active"
          ) &&
          event.key === "Enter"
        ) {
          // Reset all tabs
          tabs.forEach((el) => {
            el.classList.remove("content-tabs__tab--active");
            const icon = el.querySelector(".icon");
            if (icon) {
              icon.classList.remove("icon-minus");
              icon.classList.add("icon-plus");
              const svg = icon.querySelector("svg");
              svg.innerHTML = `
                <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
                </foreignObject>
                <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
                <path d="M20.9111 15L20.9111 25" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <path d="M15.9048 20H25.9175" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <defs>
                  <clipPath id="bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                    <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                  </clipPath>
                </defs>
              `;
            }
          });

          // Set active tab and icon
          tab.classList.add("content-tabs__tab--active");
          const icon = tab.querySelector(".icon");
          if (icon) {
            icon.classList.remove("icon-plus");
            icon.classList.add("icon-minus");
            const svg = icon.querySelector("svg");
            svg.innerHTML = `
              <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
              </foreignObject>
              <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
              <path d="M15.9048 20H25.9175" stroke="#858585" stroke-width="3" stroke-linecap="round"/>
              <defs>
                <clipPath id="bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                  <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                </clipPath>
              </defs>
            `;
          }

          setActiveContent(section, currentId);
        }
      });
    });
  };

  const setWidthForAfter = (section) => {
    const wrapper = section.querySelector(".content-tabs__tabs-wrapper");
    if (!wrapper) return;

    const setVariable = (el) => {
      el.style.setProperty("--wrapper-border-width", `0px`);
      const elScrollWidth = el.scrollWidth;
      el.style.setProperty("--wrapper-border-width", `${elScrollWidth}px`);
    };

    setVariable(wrapper);

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setVariable(entry.target);
      });
    });
    resizeObserver.observe(wrapper);
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;

    toggleTab(section);
    setWidthForAfter(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section-product-card-slider .button__label').forEach(button => {
        button.classList.remove('button__label');
    });
});